import config from 'js/app/config';

import type { LinkInfo } from 'bundles/seo/CourseraMetatagsV2Types';
import { PAGE_TYPE } from 'bundles/unified-seo-content-common/constants';
import type { SEOContentPageType } from 'bundles/unified-seo-content-common/types';
import { getPageLink } from 'bundles/unified-seo-content-common/utils';

const DEFAULT_REGION = 'us';

type Locale = {
  language: string;
  region: string;
};

function createAlternateLink({ region, language }: Locale) {
  return function (href: string) {
    return {
      rel: 'alternate',
      hreflang: language === region ? region : `${language}-${region}`,
      href,
    };
  };
}

export const createCanonicalLink = (
  slug: string,
  seoContentPageType: SEOContentPageType,
  localeCode?: Locale
): string => {
  const pageLink = getPageLink({
    pageType: PAGE_TYPE.content,
    seoContentPageType,
    slug,
    localizedCountryCode: localeCode?.region?.toUpperCase(),
    localizedLanguageCode: localeCode?.language,
  });

  return `${config.url.domain}${pageLink}`;
};

export function toSubFolderLink({ region, language }: Locale, slug: string, pageType: SEOContentPageType): LinkInfo {
  return createAlternateLink({ region, language })(
    createCanonicalLink(slug, pageType, region === DEFAULT_REGION ? undefined : { language, region })
  );
}
